import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const SET_GALLERY_ENABLED = `${API_URL}/api/v1/parent/video-nudity-monitor`;

export function setGalleryEnabledData(payload) {
  return axiosInstance({
    url: SET_GALLERY_ENABLED,
    method: "PUT",
    data: payload,
  });
}
